import { request } from './xcalacocoRequest'

export function fetchBeachClubBookings(context, filters) {
  const cleanParams = {}
  Object.keys(filters || {}).forEach(key => {
    const value = filters[key]
    if (value !== null && value !== undefined && value !== '') cleanParams[key] = value
  })
  return request({ url: '/xcalacoco/getBeachClubBookingsAdmin/', method: 'GET', params: cleanParams })
}

export function fetchBeachClubBooking(context, id) {
  return request({ url: '/xcalacoco/getBeachClubBookingAdmin/', method: 'GET', params: { id } })
}

export function updateBeachClubBooking(context, body) {
  return request({ url: '/xcalacoco/updateBeachClubBookingAdmin/', method: 'PUT', data: body })
}

export function setBeachClubBookingStatus(context, body) {
  return request({ url: '/xcalacoco/setBeachClubBookingStatus/', method: 'PUT', data: body })
}
